export const STATUS_CATEGORY = {
  NOT_STARTED: 'Not started',
  STARTED: 'Started',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
} as const;

export type StatusCategoryType = (typeof STATUS_CATEGORY)[keyof typeof STATUS_CATEGORY];
export const isStatusCategory = (x: string): x is StatusCategoryType => Object.keys(STATUS_CATEGORY).includes(x);
